import { render, staticRenderFns } from "./ExploreManagerPage.vue?vue&type=template&id=22357c84"
import script from "./ExploreManagerPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExploreManagerPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports